<template>
  <el-row>
    <slot></slot>
  </el-row>
</template>
<script>
export default {
  name: "s-action-header",
  props: {
    gutter: {
      type: Number,
      default: 30
    }
  },
  data() {
    return {};
  }
};
</script>